<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('sidebar.setting.registrar.transcriptTitle')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">

                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <div class="row">
                    <div class="col-md-12">
                        <div class="card" v-if="toggleForm">
                            <div class="card-header bg-light">
                                <div class="card-title">{{$t('form.setting.addNew')}}</div>
                            </div>
                            <div class="card-body">
                                <div class="form-group">
                                    <label>{{$t('form.setting.name')}}</label>
                                    <input type="text" class="form-control" v-model="name">
                                </div>
                                <b-button variant="primary" @click="submit">{{$t('button.save')}}</b-button>
                            </div>
                        </div>

                        <div class="card" v-else>
                            <div class="card-header bg-light">
                                <div class="card-title">{{$t('form.setting.edit')}} {{type | capitalize}}</div>
                            </div>
                            <div class="card-body">
                                <div class="form-group">
                                    <label>{{$t('form.setting.name')}}</label>
                                    <input type="text" class="form-control" v-model="name">
                                </div>

                                <b-button variant="primary" @click="update">{{$t('button.update')}}</b-button>
                                <b-button variant="outline-primary" @click="cancel">{{$t('button.cancel')}}</b-button>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-header bg-light">
                                <div class="card-title">{{$t('form.program.transcriptTitle')}}</div>
                            </div>
                            <div class="card-body table-responsive p-0">
                                <table class="table table-hover" v-if="transcriptTitles.length">
                                    <thead>
                                        <tr class="header">
                                            <th>{{$t('form.setting.name')}}</th>
                                            <th class="text-right">{{$t('form.setting.action')}}</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr v-for="(row, index) in transcriptTitles" :key="index">
                                            <td>{{row.name}}</td>

                                            <td class="text-right">
                                                <button v-if="permissions.editSettingsProgramtranscripttitle"
                                                    class="btn btn-info btn-sm" @click="edit(row)">
                                                    <i class="fas fa-edit"></i>
                                                </button>
                                                <button v-if="permissions.deleteSettingsProgramtranscripttitle"
                                                    class="btn btn-danger btn-sm" @click="remove(row, index)">
                                                    <i class="fas fa-trash"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <p class="p-3 m-0" v-else>{{$t('noRecord')}}</p>
                            </div>

                            <pagination v-if="codesPagination.last_page > 1"
                                :pagination="codesPagination" :offset="5" @paginate="paginate()">
                            </pagination>
                        </div>
                    </div>

                </div>

                <div class="row">

                </div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        props: ['permissions', 'dateFormat'],

        data() {
            return {
                alert: false,
                alertClass: '',
                alertMessage: '',

                isLoading: false,
                fullPage: true,
                toggleForm: true,

                codesPagination: {
                    current_page: 1
                },
                typesPagination: {
                    current_page: 1
                },

                name: '',
                id: '',
                type: 'transcriptTitle',

                transcriptTitles: [],
                majors: []
            }
        },

        mounted() {
            if (!this.permissions.viewSettingsProgramcodestypes) {
                return this.$router.push('/');
            }

            this.getTranscriptTitles();
        },

        methods: {

            getTranscriptTitles() {
                this.isLoading = true;
                axios
                    .get('/api/program-transcript-titles?type=transcriptTitle&page=' + this.typesPagination.current_page)
                    .then(response => {
                        this.transcriptTitles = response.data.data.data;
                        this.typesPagination = response.data.pagination;
                        this.isLoading = false;
                    })
                    .catch(error => {
                        this.isLoading = false;
                        console.log('error fetching program types');
                    });
            },


            paginate(type = null) {

                this.getTranscriptTitles();
                return;
            },

            submit() {
                if (this.name == '') {
                    this.showAlert('Please add name to continue.', 'danger');
                    return;
                }

                this.clear();
                this.isLoading = true;

                axios
                    .post(`/api/program-transcript-titles`, {
                        name: this.name,
                        type: this.type
                    })
                    .then(response => {

                        if (response.data.success) {
                            this.name = '';
                            this.showAlert(response.data.message);
                            this.transcriptTitles.unshift(response.data.data);
                        }
                        this.isLoading = false;
                    })
                    .catch(error => {
                        if (error.response.data.error) {
                            this.showAlert(error.response.data.message, 'danger');
                        }

                        this.isLoading = false;
                    })
            },

            edit(item) {
                this.id = item.id;
                this.name = item.name;
                this.toggleForm = false;
            },

            update() {
                if (this.name == '') {
                    this.showAlert('Please add name to continue.', 'danger');
                    return;
                }

                this.clear();
                this.isLoading = true;

                axios
                    .put(`/api/program-transcript-titles/${this.id}`, {
                        name: this.name,
                        type: this.type
                    })
                    .then(response => {
                        if (response.data.success) {
                            this.showAlert(response.data.message);

                            this.transcriptTitles.map(r => {
                                    if (r.id == this.id) {
                                        r.id = response.data.data.id;
                                        r.name = response.data.data.name;
                                    }
                                });
                            this.cancel();
                        }

                        this.isLoading = false;
                    })
                    .catch(error => {
                        if (error.response.data.error) {
                            this.showAlert(error.response.data.message, 'danger');
                        }

                        this.isLoading = false;
                    })
            },

            cancel() {
                this.id = '';
                this.name = '';
                this.toggleForm = true;
            },

            remove(item, index, type = null) {
                if (!confirm(this.$t('form.validation.delete'))) {
                    return;
                }

                this.clear();
                this.isLoading = true;

                axios
                    .delete(`/api/program-transcript-titles/${item.id}`)
                    .then(response => {
                        this.isLoading = false;

                        if (response.data.success) {
                            this.showAlert(response.data.message);
                            this.transcriptTitles.splice(index, 1);
                        }
                    })
                    .catch(error => {
                        if (error.response.status === 422) {
                            this.showAlert(error.response.data.message, 'danger');
                        }
                        this.isLoading = false;
                    })
            },

            showAlert(msg, cls = 'success') {
                this.alertMessage = msg;
                this.alertClass = cls;
                this.alert = true;
            },

            clear() {
                this.alert = false;
                this.message = '';
                this.alertClass = '';
            }
        }
    }

</script>
